export default [
    '20 ft',
    '40 ft',
    '40 ft\'HC',
]